
import React, { useState } from 'react';
import { Outlet } from 'react-router-dom';
import Navbar from './Navbar';
import Sidebar from './Sidebar';

const Layout = ({ userData }) => {
  const [isExpanded, setIsExpanded] = useState(false);

  return (
    <div className="min-h-screen bg-gray-50">
      <Navbar userData={userData} />
      <Sidebar isExpanded={isExpanded} onExpandChange={setIsExpanded} />
      <main className={`transition-all duration-300 ${isExpanded ? 'ml-[260px]' : 'ml-[70px]'} pt-16 min-h-screen bg-gray-50`}>
        <div className="px-12 py-10">
          <Outlet />
        </div>
      </main>
    </div>
  );
};

export default Layout; 